var map = {
	"./china.png": 79960,
	"./eu.png": 70469,
	"./france.png": 70825,
	"./japan.png": 62381,
	"./mexico.png": 4784,
	"./south-korea.png": 19725,
	"./spain.png": 85769,
	"./taiwan.png": 56470,
	"./thailand.png": 53036,
	"./usa.png": 45284
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20245;